import { useContext } from "react";
import { FeatureFlagContext } from "./FeatureFlagContext";
import type { FeatureFlagKey } from "shared/featureFlags";

/**
 * Returns the full feature flag context (isEnabled, isGroupEnabled, flags, loading).
 */
export const useFeatureFlagContext = () => {
  const context = useContext(FeatureFlagContext);

  if (!context) {
    throw new Error(
      "useFeatureFlagContext must be used within a FeatureFlagProvider",
    );
  }

  return context;
};

/**
 * Convenience hook: check a single flag by key.
 * Returns false if the flag doesn't exist or no org context.
 *
 * Accepts typed keys from FeatureFlags constant or raw strings
 * (for flags created ad-hoc via the admin UI).
 */
export const useFeatureFlag = (flagKey: FeatureFlagKey | (string & {})): boolean => {
  const context = useContext(FeatureFlagContext);
  return context?.isEnabled(flagKey) ?? false;
};
